import { minicartQuantitySelector } from '@state/features/minicart.selectors';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import api from '@utils/api';
import React, { useEffect, useMemo, useState, Suspense } from 'react';
import { useSelector } from 'react-redux';
import useBreakpoint from '@common/utils/useBreakpoint';
import customEventBus from '@common/scripts/libs/eventBus';
import SearchApp from '../search/SearchApp';
import LoginModal from '@stone/components/login/LoginModal';
const MiniBagWrapper = React.lazy(() => import('@stone/components/minibag/MiniBagWrapper'));
const MenuDesktop = React.lazy(() => import('@stone/components/menu/MenuDesktop'));
const MenuMobile = React.lazy(() => import('@stone/components/menu/MenuMobile'));
const SESSIONSTORAGE_KEY = 'ti_re';
const MenuWrapper = (props) => {
    // * CUSTOM HOOKS ------------------------------------------------------------------------------------------------
    const { isMobile } = useMediaQueries();
    const currentBreakpoint = useBreakpoint();
    // * STATE ------------------------------------------------------------------------------------------------
    const [tickerSlides, setTickerSlides] = useState(null);
    const [data, setData] = useState(null);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [whatIntent, setWhatIntent] = useState('mouse');
    const [dataHeader, setDataHeader] = useState({
        color: '',
        transparent: '',
    });
    // const [searchData, setSearchData] = useState<menuModels.SearchData>(null);
    const [suggestions, setSuggestions] = useState(null);
    const [clientServices, setClientServices] = useState(null);
    const [promoCards, setPromoCards] = useState(null);
    const [contacts, setContacts] = useState();
    const [localLoading, setLocalLoading] = useState(false);
    const [siteRegion, setSiteRegion] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [transparent, setTransparent] = useState(props.transparent);
    const [color, setColor] = useState(props.color);
    const [loginOpen, setLoginOpen] = useState(false);
    const [profileName, setProfileName] = useState(props.profileName);
    const searchData = {
        suggestions,
        clientServices,
        promoCards,
        contacts,
        minSearchChars: props.minSearchChars,
        searchDebounceTimeout: parseInt(props.searchDebounceTimeout),
    };
    useEffect(() => {
        customEventBus.on('account:update', (data) => {
            if (data === null || data === void 0 ? void 0 : data.customerName) {
                setProfileName(data.customerName);
            }
        });
        customEventBus.on('header:settrasparency', (data) => {
            setTransparent(data.transparent);
            setColor(data.color);
        });
        customEventBus.on('keyboard:mode', (data) => {
            setWhatIntent(data.isKeyboardMode ? 'keyboard' : 'mouse');
        });
    }, []);
    // * USE EFFECT ----------------------------------------------------------------------------------------------------------------------------------------
    //GET MENU
    useEffect(() => {
        if (!data) {
            setLoading(true);
            api
                .getPageJson('menu', true)
                .then((data) => {
                const sections = data.regions.find((s) => s.id === 'sections');
                if (sections === null || sections === void 0 ? void 0 : sections.components) {
                    setData(sections.components);
                    setLoading(false);
                }
                extractTickerSlides(data);
            })
                .catch((error) => setError(error));
        }
    }, []);
    //GET SEARCH
    useEffect(() => {
        setLocalLoading(true);
        api.getPageJson('search').then((res) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (res.page) {
                let suggestions, promoCards, clientServices;
                suggestions = (_b = (_a = res === null || res === void 0 ? void 0 : res.page) === null || _a === void 0 ? void 0 : _a.regions) === null || _b === void 0 ? void 0 : _b.suggestions;
                promoCards = (_e = (_d = (_c = res === null || res === void 0 ? void 0 : res.page) === null || _c === void 0 ? void 0 : _c.regions) === null || _d === void 0 ? void 0 : _d.promo_cards) === null || _e === void 0 ? void 0 : _e.components;
                clientServices = (_g = (_f = res === null || res === void 0 ? void 0 : res.page) === null || _f === void 0 ? void 0 : _f.regions) === null || _g === void 0 ? void 0 : _g.client_services;
                setSuggestions(suggestions);
                setPromoCards(promoCards);
                setClientServices(clientServices);
                const cCode = window.country;
                api.GetContactsByCountry(cCode).then((data) => {
                    var _a, _b;
                    if (data) {
                        if (cCode.toLowerCase() === window.country.toLowerCase() && !siteRegion) {
                            setSiteRegion((_a = data.chatConfig) === null || _a === void 0 ? void 0 : _a.region);
                        }
                        else {
                            if (siteRegion !== ((_b = data.chatConfig) === null || _b === void 0 ? void 0 : _b.region)) {
                                customEventBus.emit('contacts:live-chat', { hide: true });
                            }
                            else {
                                customEventBus.emit('contacts:live-chat', { hide: false });
                            }
                        }
                        setContacts(data);
                        setLocalLoading(false);
                    }
                });
            }
        });
    }, []);
    //CHECK INPUT MODE
    useEffect(() => {
        document.addEventListener('keydown', onKeyDown, false);
        return () => document.removeEventListener('keydown', onKeyDown, false);
    }, []);
    // * REDUX ------------------------------------------------------------------------------------------------
    const { justAdded, hovering, lastAdded, minicart } = useSelector((state) => state.minicart);
    const numItems = useSelector(minicartQuantitySelector);
    // * MEMOS ------------------------------------------------------------------------------------------------
    // Total products in cart - initiallly use the prop while redux state loads
    const definitiveTotal = useMemo(() => {
        return numItems !== null && numItems !== void 0 ? numItems : props.totalItems;
    }, [numItems]);
    // * FUNCTIONS ------------------------------------------------------------------------------------------------
    function onKeyDown(e) {
        if (e.key === 'Escape') {
            setIsCartOpen(false);
            setIsSearchOpen(false);
        }
    }
    function extractTickerSlides(data) {
        var _a, _b, _c, _d, _e;
        if (window.sessionStorage) {
            let blocker = window.sessionStorage.getItem(SESSIONSTORAGE_KEY);
            if (blocker === '1')
                return false;
        }
        const tickerRegion = (_a = data.regions) === null || _a === void 0 ? void 0 : _a.find((s) => s.id === 'ticker_region');
        const tickerWrapper = (_d = (_c = (_b = tickerRegion === null || tickerRegion === void 0 ? void 0 : tickerRegion.components) === null || _b === void 0 ? void 0 : _b.find((s) => s.type_id === 'header_ticker')) === null || _c === void 0 ? void 0 : _c.regions) === null || _d === void 0 ? void 0 : _d.find((s) => s.id === 'wrapper');
        const slideData = (_e = tickerWrapper === null || tickerWrapper === void 0 ? void 0 : tickerWrapper.components) === null || _e === void 0 ? void 0 : _e.map((slide) => slide.data);
        setTickerSlides(slideData);
    }
    const toggleSearchOpen = () => {
        setIsSearchOpen(!isSearchOpen);
    };
    // if (loading) return <></>;
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            isMobile ? (React.createElement(MenuMobile, Object.assign({}, props, { isSSR: props.isSsr, isCartOpen: isCartOpen, setIsCartOpen: () => setIsCartOpen(!isCartOpen), isSearchOpen: isSearchOpen, setIsSearchOpen: () => toggleSearchOpen(), hovering: hovering, justAdded: justAdded, lastAdded: lastAdded, minicart: minicart, definitiveTotal: definitiveTotal, sections: data, transparent: transparent, color: color, searchData: searchData, setIsLoginOpen: () => {
                    setLoginOpen(true);
                }, profileName: profileName, clickFromStoreUrl: props.clickFromStoreUrl, tickerSlides: tickerSlides }))) : (React.createElement(MenuDesktop, { isSSR: props.isSsr, isCartOpen: isCartOpen, setIsCartOpen: () => setIsCartOpen(!isCartOpen), setIsSearchOpen: toggleSearchOpen, hovering: hovering, totalItems: props.totalItems, carturl: props.carturl, justAdded: justAdded, lastAdded: lastAdded, minicart: minicart, definitiveTotal: definitiveTotal, sections: data, transparent: transparent, color: color, searchData: searchData, forgotpasswordform: props.forgotpasswordform, profileName: profileName, setIsLoginOpen: () => {
                    setLoginOpen(true);
                }, whatIntent: whatIntent, clickFromStoreUrl: props.clickFromStoreUrl, tickerSlides: tickerSlides })),
            React.createElement(LoginModal, { forgotpasswordform: props.forgotpasswordform, modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status), rememberme: props.rememberme, drawer: true }),
            React.createElement(SearchApp, { isOpen: isSearchOpen, handleClose: toggleSearchOpen, searchData: searchData }),
            React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) }, !window.unshoppable && React.createElement(MiniBagWrapper, { totalItems: definitiveTotal })))));
};
export default MenuWrapper;
